import React, { useState } from 'react';
import { Box } from '@mui/material';
import { CustomSwitch } from 'Components/StyledComponents';
import { FeatureFlag, getAllFeatureFlags, setFeatureFlag } from 'Utils/FeatureFlags';

const FEATURE_FLAG_LABELS: Record<FeatureFlag, string> = {
  [FeatureFlag.USE_OSMD_PHASER_BACKEND]: 'OSMD Phaser backend',
  [FeatureFlag.USE_LESSON_ZOOM]: 'Lesson zoom',
  [FeatureFlag.USE_ERROR_FEEDBACK]: 'Error feedback',
  [FeatureFlag.USE_ADAPTIVE_TEMPO]: 'Adaptive tempo',
  [FeatureFlag.USE_MOBILE_SIGHT_READING]: 'Mobile sight reading',
  [FeatureFlag.USE_LOOPING]: 'Looping',
};

const ExperimentalFeatures = () => {
  const [flags, setFlags] = useState<Record<FeatureFlag, boolean>>(() => getAllFeatureFlags());

  const handleToggle = (flag: FeatureFlag) => {
    const next = !flags[flag];
    setFeatureFlag(flag, next);
    setFlags((prev) => ({ ...prev, [flag]: next }));
  };

  return (
    <Box sx={{ height: 'calc(100vh - 200px)', overflow: 'scroll' }}>
      <Box
        sx={{
          marginLeft: '50px',
          width: '600px',
          backgroundColor: 'black',
          borderRadius: '5px',
        }}
      >
        <Box
          sx={{
            color: 'white',
            textAlign: 'left',
            marginLeft: '24px',
            marginRight: '24px',
            marginTop: '20px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              marginTop: '20px',
              marginBottom: '20px',
              fontStyle: 'normal',
              fontWeight: '400',
              fontSize: '26px',
              letterSpacing: '0.01em',
              color: '#FFFFFF',
              fontFamily: 'Lato',
            }}
          >
            Experimental Features
          </Box>

          <Box sx={{ marginBottom: '20px', fontFamily: 'Lato' }}>
            {Object.values(FeatureFlag).map((flag) => (
              <Box
                key={flag}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  marginBottom: '8px',
                }}
              >
                <CustomSwitch checked={flags[flag]} onChange={() => handleToggle(flag)} />
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    height: '25px',
                    marginLeft: '8px',
                  }}
                >
                  {FEATURE_FLAG_LABELS[flag]}
                </Box>
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ExperimentalFeatures;
